import { render, staticRenderFns } from "./RightArrow.vue?vue&type=template&id=ca5f26ca&scoped=true"
import script from "./RightArrow.vue?vue&type=script&lang=js"
export * from "./RightArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5f26ca",
  null
  
)

export default component.exports